/**
 * Positional node ids for taxonomies whose wire payload carries no whole-tree identifier.
 *
 * An id is the node's positional path from the root (`"0.3.12"`), not its name path. Names are neither
 * unique nor free of the separator — a sub-category called "A.B" would have collided two distinct nodes
 * into one `byId` entry, checking and unchecking as one. Indices carry no such hazard, and the level
 * falls out of the path rather than needing a walk up `parentById`.
 *
 * These ids are never persisted, so their instability under a backend reordering costs nothing. A
 * taxonomy that must survive a reorder needs stable ids from the wire instead.
 */
const PATH_SEPARATOR = ".";

export const createPositionalNodeId = <TId extends string>(pathIndices: readonly number[]): TId =>
    pathIndices.join(PATH_SEPARATOR) as TId;

/** Depth of a node, read straight off its positional path. Roots are level 0. */
export const positionalNodeLevelOf = (id: string): number => id.split(PATH_SEPARATOR).length - 1;
